import React, { useEffect, useRef, useState } from 'react'
import * as opdRegisteredCrud from '../../../configurations/crud/opdRegisteredCrud'
import { useToast } from '../../controls/Toast/ToastService';
import { MdErrorOutline } from 'react-icons/md';
import StatusContainer from '../../controls/StatusContainer';
import { ESourceBg, GetESourceName } from '../../../configurations/enums/ESource';
import { ETypeBg, GetETypeName } from '../../../configurations/enums/EType';
import { EOPDConfirmedStatusBg, GetEOPDConfirmedStatusName } from '../../../configurations/enums/EOPDConfirmedStatus';
import useDebounce from '../../../configurations/commonlib/useDebounce';
import { useParams } from 'react-router-dom';
import { PAGE_SIZE } from '../../../configurations/initUrls';
import Paging from '../../controls/Paging';
import LoadingContainer from '../../controls/LoadingContainer';
import { PrintStarter } from '../settings/Prints/PrintStarter';
import { ConfirmOpdPrint } from '../settings/Prints/ConfirmOpdPrint';
import { PrescriptionLetterPrint } from '../settings/Prints/PrescriptionLetterPrint';
import { GetEGenderName } from '../../../configurations/enums/EGender';
import useGlobalLoader from '../../../configurations/useGlobalLoader';
import Empty from '../../controls/Empty';


export default function ReceptionConfirmed({ isActive, searchTerm, isSearch }) {
  const { start, end } = useGlobalLoader()
  const { centerid } = useParams()
  const toast = useToast()
  const [loding, setLoding] = useState(false)
  const [LastPage, setLastPage] = useState(1);
  const [pagingData, setPagingData] = useState();
  const [confirmData, setConfirmData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1)
  const [printData, setPrintData] = useState()
  const printRef = useRef();
  const printLetterRef = useRef();

  useEffect(() => {
    if (isActive) {
      onSearch()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSearch])

  const OnPageChange = (e) => {
    setCurrentPage(e)
    GetTodaysConfirmed({
      CenterId: centerid,
      PageNo: e,
      PageSize: PAGE_SIZE,
      SearchTerm: searchTerm
    })
  }

  const onSearch = () => {
    GetTodaysConfirmed({
      CenterId: centerid,
      PageNo: 1,
      PageSize: PAGE_SIZE,
      SearchTerm: searchTerm
    })
  }
  const GetTodaysConfirmed = (params) => {
    setLoding(true)
    start()
    opdRegisteredCrud.GetTodaysConfirmed(params).then(res => {
      let mdata = res.data
      if (mdata.result.succeeded) {
        setConfirmData(mdata.data)
        setPagingData(mdata.paging)
        setLastPage(mdata.paging.pageCount)
      } else {
        setPagingData()
        setLastPage(1)
        setConfirmData([])
        // toast.open(mdata.result.message, <MdErrorOutline />, "danger")
      }
      setLoding(false)
      end()
    }).catch(errors => {
      setPagingData()
      setLastPage(1)
      setConfirmData([])
      // toast.open(errors, <MdErrorOutline />, "danger")
      setLoding(false)
      end()
      toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
    })
  }

  // three badges: status / type / source
  const renderBadges = (item) => (
    <div className="flex items-center gap-1.5">
      <StatusContainer bg={EOPDConfirmedStatusBg(item.status)} text={GetEOPDConfirmedStatusName(item.status)} />
      <StatusContainer bg={ETypeBg(item.type)} text={GetETypeName(item.type)} />
      <StatusContainer bg={ESourceBg(item.source)} text={GetESourceName(item.source)} />
    </div>
  )

  // print actions (web only)
  const renderPrint = (item) => (
    <div className="flex items-center gap-1">
      <PrintStarter printRef={printRef} setPrintData={setPrintData} item={item} title="Print slip" />
      <PrintStarter printRef={printLetterRef} setPrintData={setPrintData} item={item} color='blue' title="Print prescription letter" />
    </div>
  )

  return (
    <div className="text-gray-700">
      <div style={{ display: "none" }}>
        <ConfirmOpdPrint printData={printData} ref={printRef} />
        <PrescriptionLetterPrint printData={printData} ref={printLetterRef} />
      </div>

      <Paging LastPage={LastPage} CurrentPage={currentPage} OnPageChange={OnPageChange} pagingData={pagingData}>

        {loding ? (
          <LoadingContainer text="Fetching..." />
        ) : confirmData.length > 0 ? (
          <>
            {/* ===== desktop table ===== */}
            <div className="hidden overflow-x-auto sm:block">
              <table className="w-full border-collapse text-left text-sm text-gray-500">
                <thead>
                  <tr className="bg-gray-100 text-xs uppercase tracking-wide text-gray-500">
                    <th scope="col" className="px-3 py-3 font-semibold">Print</th>
                    <th scope="col" className="px-3 py-3 font-semibold">Ref.No</th>
                    <th scope="col" className="px-3 py-3 font-semibold">Conf./Old</th>
                    <th scope="col" className="px-3 py-3 font-semibold">Name</th>
                    <th scope="col" className="px-3 py-3 font-semibold">Phone</th>
                    <th scope="col" className="px-3 py-3 font-semibold">Age</th>
                    <th scope="col" className="px-3 py-3 font-semibold">Status/Type/Source</th>
                    <th scope="col" className="px-3 py-3 font-semibold">Address</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-100">
                  {confirmData.map((item, index) => (
                    <tr key={index} className="bg-white hover:bg-gray-50">
                      <td className="px-3 py-2.5">
                        <div className="flex items-center justify-center gap-1">{renderPrint(item)}</div>
                      </td>
                      <td className="whitespace-nowrap px-3 py-2.5">{item.id}{item.registeredIdForRef && "/" + item.registeredIdForRef}</td>
                      <td className="whitespace-nowrap px-3 py-2.5">
                        <span className="font-bold text-green-500">{item.confirmedAllotedNumber}</span>/ {item.opdNumberAlloted}
                      </td>
                      <td className="whitespace-nowrap px-3 py-2.5 font-bold text-gray-800">
                        {item.patientName} <span className="text-[9px] font-normal text-gray-400">({GetEGenderName(item.gender)})</span>
                      </td>
                      <td className="px-3 py-2.5">{item.mobile}</td>
                      <td className="px-3 py-2.5">{item.age}</td>
                      <td className="px-3 py-2.5">{renderBadges(item)}</td>
                      <td className="whitespace-nowrap px-3 py-2.5">{item.patientAddress}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* ===== mobile cards ===== */}
            <div className="space-y-2 p-2 text-left sm:hidden">
              {confirmData.map((item, index) => (
                <div key={index} className="border-b-2 border-gray-100 bg-white p-3">
                  <div className="flex items-start justify-between gap-2">
                    <div className="min-w-0">
                      <div className="font-bold text-gray-900">
                        {item.patientName} <span className="text-xs font-normal text-gray-400">({GetEGenderName(item.gender)})</span>
                      </div>
                      <div className="mt-0.5 text-xs text-gray-500">
                        Ref: {item.id}{item.registeredIdForRef && "/" + item.registeredIdForRef} · Age: {item.age}
                      </div>
                      <div className="mt-0.5 text-xs text-gray-500">
                        Conf/Old: <span className="font-bold text-green-600">{item.confirmedAllotedNumber}</span>/{item.opdNumberAlloted}
                      </div>
                    </div>
                    <div className="shrink-0">{renderPrint(item)}</div>
                  </div>
                  <div className="mt-2 space-y-1 text-xs text-gray-600">
                    <div><span className="text-gray-400">Phone: </span>{item.mobile}</div>
                    <div><span className="text-gray-400">Address: </span>{item.patientAddress}</div>
                  </div>
                  <div className="mt-2">{renderBadges(item)}</div>
                </div>
              ))}
            </div>
          </>
        ) : (
          <Empty>No Items Found.</Empty>
        )}
      </Paging>

      <div className="pb-4" />
    </div>
  )
}